import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { useConnectionContext } from '@sorare/core/src/contexts/connection';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import footerAvif from './assets/footer.avif';
import footer from './assets/footer.jpg';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--double-unit);
  --img-position: center;
  background:
    linear-gradient(
      to bottom,
      rgba(var(--c-rgb-neutral-100), 0) 0%,
      rgba(var(--c-rgb-neutral-100), 1) 100%
    ),
    no-repeat center / cover
      image-set(
        url(${footerAvif}) type('image/avif'),
        url(${footer}}) type('image/jpeg')
      );

  font-size: var(--fs-landing-title);
  height: 310px;
  @media ${tabletAndAbove} {
    height: 588px;
  }
`;

export const Footer = () => {
  const { signUp } = useConnectionContext();

  return (
    <Root className="text-center">
      <FormattedMessage
        id="landing.EarlyAccess.Footer.title"
        defaultMessage="Your new football home"
      />
      <Button color="secondary" size="medium" onClick={signUp}>
        <FormattedMessage
          id="landing.EarlyAccess.Footer.cta"
          defaultMessage="Join our community"
        />
      </Button>
    </Root>
  );
};
